module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"specifications":"Spécifications","documents-completed":"Documents complétés","specific-indicators":"Indicateurs spécifiques"},"en":{"specifications":"Specifications","documents-completed":"Completed documents","specific-indicators":"Specific indicators"}}')
  delete Component.options._Ctor
}
